var map = {
	"./example.svg": "d9bc",
	"./q1-0.svg": "79fc",
	"./q1-1-0.svg": "89b3",
	"./q1-1-1.svg": "3242",
	"./q1-1-2.svg": "c8f1",
	"./q1-1-3.svg": "546f",
	"./q1-1.svg": "fb73",
	"./q1-10-0.svg": "b38b",
	"./q1-10-1.svg": "7d9d",
	"./q1-10-2.svg": "fa51",
	"./q1-10-3.svg": "2063",
	"./q1-100-0.svg": "22d6",
	"./q1-100-1.svg": "7356",
	"./q1-100-2.svg": "cdc3",
	"./q1-100-3.svg": "a2b3",
	"./q1-11-0.svg": "ed12",
	"./q1-11-1.svg": "9938",
	"./q1-11-2.svg": "2501",
	"./q1-11-3.svg": "528f",
	"./q1-12-0.svg": "506ea",
	"./q1-12-1.svg": "b7c1",
	"./q1-12-2.svg": "8755",
	"./q1-12-3.svg": "f9f1",
	"./q1-13-0.svg": "7f76",
	"./q1-13-1.svg": "b736",
	"./q1-13-2.svg": "36b7",
	"./q1-13-3.svg": "d520",
	"./q1-14-0.svg": "3999",
	"./q1-14-1.svg": "5a72",
	"./q1-14-2.svg": "b076",
	"./q1-14-3.svg": "1688",
	"./q1-15-0.svg": "6e8b",
	"./q1-15-1.svg": "fe92",
	"./q1-15-2.svg": "29735",
	"./q1-15-3.svg": "5b9a",
	"./q1-16-0.svg": "cd77",
	"./q1-16-1.svg": "e86d",
	"./q1-16-2.svg": "6a77",
	"./q1-16-3.svg": "9403",
	"./q1-17-0.svg": "4123",
	"./q1-17-1.svg": "9867",
	"./q1-17-2.svg": "5957",
	"./q1-17-3.svg": "8e45",
	"./q1-18-0.svg": "d092",
	"./q1-18-1.svg": "8a72",
	"./q1-18-2.svg": "7ce8",
	"./q1-18-3.svg": "92d0",
	"./q1-19-0.svg": "aa826",
	"./q1-19-1.svg": "f61d",
	"./q1-19-2.svg": "7aea",
	"./q1-19-3.svg": "5235",
	"./q1-2-0.svg": "67ad",
	"./q1-2-1.svg": "4fab",
	"./q1-2-2.svg": "ab29",
	"./q1-2-3.svg": "f4ef",
	"./q1-2.svg": "a923",
	"./q1-20-0.svg": "76ff",
	"./q1-20-1.svg": "938c",
	"./q1-20-2.svg": "1f6eb",
	"./q1-20-3.svg": "f657",
	"./q1-21-0.svg": "5494",
	"./q1-21-1.svg": "1984",
	"./q1-21-2.svg": "1943",
	"./q1-21-3.svg": "58c5",
	"./q1-22-0.svg": "6dfc",
	"./q1-22-1.svg": "85a3",
	"./q1-22-2.svg": "8d5f",
	"./q1-22-3.svg": "128c",
	"./q1-23-0.svg": "6a3a",
	"./q1-23-1.svg": "1140",
	"./q1-23-2.svg": "5d5c",
	"./q1-23-3.svg": "9c0ab",
	"./q1-24-0.svg": "4815",
	"./q1-24-1.svg": "6d50",
	"./q1-24-2.svg": "cd5e",
	"./q1-24-3.svg": "1085",
	"./q1-25-0.svg": "96ed",
	"./q1-25-1.svg": "09a5",
	"./q1-25-2.svg": "85ab2",
	"./q1-25-3.svg": "16db",
	"./q1-26-0.svg": "59df",
	"./q1-26-1.svg": "b14d",
	"./q1-26-2.svg": "c8df",
	"./q1-26-3.svg": "8a6b",
	"./q1-27-0.svg": "33f6",
	"./q1-27-1.svg": "a0b4",
	"./q1-27-2.svg": "0001",
	"./q1-27-3.svg": "8152",
	"./q1-28-0.svg": "731a",
	"./q1-28-1.svg": "c02e",
	"./q1-28-2.svg": "1477",
	"./q1-28-3.svg": "b002",
	"./q1-29-0.svg": "2d4f",
	"./q1-29-1.svg": "d1cf",
	"./q1-29-2.svg": "73a6",
	"./q1-29-3.svg": "942b",
	"./q1-3-0.svg": "6b8a",
	"./q1-3-1.svg": "96de",
	"./q1-3-2.svg": "83a0",
	"./q1-3-3.svg": "b65f",
	"./q1-3.svg": "2488",
	"./q1-30-0.svg": "af4c",
	"./q1-30-1.svg": "803e",
	"./q1-30-2.svg": "68c5",
	"./q1-30-3.svg": "f476",
	"./q1-31-0.svg": "33d4",
	"./q1-31-1.svg": "8d55",
	"./q1-31-2.svg": "499f",
	"./q1-31-3.svg": "4c6b",
	"./q1-32-0.svg": "3e75",
	"./q1-32-1.svg": "ac81",
	"./q1-32-2.svg": "8c22",
	"./q1-32-3.svg": "47c2",
	"./q1-33-0.svg": "fab7",
	"./q1-33-1.svg": "8dbf",
	"./q1-33-2.svg": "4513",
	"./q1-33-3.svg": "5c42c",
	"./q1-34-0.svg": "1838",
	"./q1-34-1.svg": "a137",
	"./q1-34-2.svg": "6264",
	"./q1-34-3.svg": "0e9e",
	"./q1-35-0.svg": "2fbc",
	"./q1-35-1.svg": "e6e4",
	"./q1-35-2.svg": "b876",
	"./q1-35-3.svg": "83da3",
	"./q1-36-0.svg": "96ce",
	"./q1-36-1.svg": "4ea0",
	"./q1-36-2.svg": "e852",
	"./q1-36-3.svg": "c219",
	"./q1-37-0.svg": "9ab4",
	"./q1-37-1.svg": "ebb8",
	"./q1-37-2.svg": "694f",
	"./q1-37-3.svg": "ee79",
	"./q1-38-0.svg": "1cda",
	"./q1-38-1.svg": "4496",
	"./q1-38-2.svg": "0c8d",
	"./q1-38-3.svg": "1251",
	"./q1-39-0.svg": "73aa",
	"./q1-39-1.svg": "abb8",
	"./q1-39-2.svg": "f859",
	"./q1-39-3.svg": "b408",
	"./q1-4-0.svg": "3a99",
	"./q1-4-1.svg": "bbe31",
	"./q1-4-2.svg": "cb84",
	"./q1-4-3.svg": "791c",
	"./q1-40-0.svg": "5163",
	"./q1-40-1.svg": "0f7e",
	"./q1-40-2.svg": "e0c1",
	"./q1-40-3.svg": "78c1",
	"./q1-41-0.svg": "2753",
	"./q1-41-1.svg": "45bc",
	"./q1-41-2.svg": "e5bf",
	"./q1-41-3.svg": "ff30",
	"./q1-42-0.svg": "cfc8",
	"./q1-42-1.svg": "7c80",
	"./q1-42-2.svg": "cc6c2",
	"./q1-42-3.svg": "0122",
	"./q1-43-0.svg": "ef83",
	"./q1-43-1.svg": "90a8",
	"./q1-43-2.svg": "e0d7",
	"./q1-43-3.svg": "4194",
	"./q1-44-0.svg": "7e63a",
	"./q1-44-1.svg": "abb2",
	"./q1-44-2.svg": "b4e3",
	"./q1-44-3.svg": "9087",
	"./q1-45-0.svg": "f7b8",
	"./q1-45-1.svg": "f57c",
	"./q1-45-2.svg": "9c4e",
	"./q1-45-3.svg": "7af1",
	"./q1-46-0.svg": "8cabb",
	"./q1-46-1.svg": "2cfb",
	"./q1-46-2.svg": "95f8",
	"./q1-46-3.svg": "3c78",
	"./q1-47-0.svg": "80ae",
	"./q1-47-1.svg": "06a1",
	"./q1-47-2.svg": "3d15",
	"./q1-47-3.svg": "a7a5",
	"./q1-48-0.svg": "fde04",
	"./q1-48-1.svg": "dc11",
	"./q1-48-2.svg": "2ad0",
	"./q1-48-3.svg": "1022",
	"./q1-49-0.svg": "d069",
	"./q1-49-1.svg": "e2cf",
	"./q1-49-2.svg": "5f32",
	"./q1-49-3.svg": "2602",
	"./q1-5-0.svg": "0794a",
	"./q1-5-1.svg": "3bd9",
	"./q1-5-2.svg": "20d6",
	"./q1-5-3.svg": "3128",
	"./q1-50-0.svg": "35b2",
	"./q1-50-1.svg": "95f9",
	"./q1-50-2.svg": "1bcc",
	"./q1-50-3.svg": "bfc4",
	"./q1-51-0.svg": "7783",
	"./q1-51-1.svg": "e9c3",
	"./q1-51-2.svg": "7962",
	"./q1-51-3.svg": "21b0",
	"./q1-52-0.svg": "0d9c",
	"./q1-52-1.svg": "be13",
	"./q1-52-2.svg": "5669",
	"./q1-52-3.svg": "10ff",
	"./q1-53-0.svg": "529e",
	"./q1-53-1.svg": "b331",
	"./q1-53-2.svg": "860e",
	"./q1-53-3.svg": "9f30",
	"./q1-54-0.svg": "9a31",
	"./q1-54-1.svg": "734a",
	"./q1-54-2.svg": "1b0a",
	"./q1-54-3.svg": "42642",
	"./q1-55-0.svg": "09ce",
	"./q1-55-1.svg": "4a69",
	"./q1-55-2.svg": "c254",
	"./q1-55-3.svg": "1e25",
	"./q1-56-0.svg": "9370",
	"./q1-56-1.svg": "ba850",
	"./q1-56-2.svg": "6ece",
	"./q1-56-3.svg": "b5756",
	"./q1-57-0.svg": "4ac8",
	"./q1-57-1.svg": "062b",
	"./q1-57-2.svg": "1386",
	"./q1-57-3.svg": "c69e",
	"./q1-58-0.svg": "9900",
	"./q1-58-1.svg": "f639",
	"./q1-58-2.svg": "580a",
	"./q1-58-3.svg": "3fd0",
	"./q1-59-0.svg": "7b8d",
	"./q1-59-1.svg": "5f2d",
	"./q1-59-2.svg": "b255",
	"./q1-59-3.svg": "45eb",
	"./q1-6-0.svg": "cf38",
	"./q1-6-1.svg": "9d2c",
	"./q1-6-2.svg": "0319",
	"./q1-6-3.svg": "7322",
	"./q1-6-4.svg": "43ef",
	"./q1-60-0.svg": "4ba4",
	"./q1-60-1.svg": "2403",
	"./q1-60-2.svg": "b70e",
	"./q1-60-3.svg": "55dc",
	"./q1-61-0.svg": "b706",
	"./q1-61-1.svg": "8d28",
	"./q1-61-2.svg": "ac73",
	"./q1-61-3.svg": "0b3e",
	"./q1-62-0.svg": "4552",
	"./q1-62-1.svg": "0904",
	"./q1-62-2.svg": "bbfa",
	"./q1-62-3.svg": "ab73",
	"./q1-63-0.svg": "c685",
	"./q1-63-1.svg": "26f1",
	"./q1-63-2.svg": "b73f",
	"./q1-63-3.svg": "7efc",
	"./q1-64-0.svg": "b2c63",
	"./q1-64-1.svg": "43cd",
	"./q1-64-2.svg": "5c04",
	"./q1-64-3.svg": "c95a",
	"./q1-65-0.svg": "33bb",
	"./q1-65-1.svg": "5947",
	"./q1-65-2.svg": "2ccf",
	"./q1-65-3.svg": "5ff2",
	"./q1-66-0.svg": "d5de",
	"./q1-66-1.svg": "5653",
	"./q1-66-2.svg": "058d",
	"./q1-66-3.svg": "49ee7",
	"./q1-67-0.svg": "391b",
	"./q1-67-1.svg": "5853",
	"./q1-67-2.svg": "d101",
	"./q1-67-3.svg": "4570",
	"./q1-68-0.svg": "a80f",
	"./q1-68-1.svg": "c408",
	"./q1-68-2.svg": "2796",
	"./q1-68-3.svg": "85c9",
	"./q1-69-0.svg": "9b8a",
	"./q1-69-1.svg": "d05f",
	"./q1-69-2.svg": "0c8a",
	"./q1-69-3.svg": "6ca6",
	"./q1-7-0.svg": "4c70",
	"./q1-7-1.svg": "f3ad",
	"./q1-7-2.svg": "51fc",
	"./q1-7-3.svg": "d0c0",
	"./q1-7-4.svg": "3336",
	"./q1-70-0.svg": "f9e68",
	"./q1-70-1.svg": "eae2",
	"./q1-70-2.svg": "3661",
	"./q1-70-3.svg": "d3d3",
	"./q1-71-0.svg": "642c",
	"./q1-71-1.svg": "3f06",
	"./q1-71-2.svg": "1c8b",
	"./q1-71-3.svg": "73ae",
	"./q1-72-0.svg": "dc56",
	"./q1-72-1.svg": "9bc6",
	"./q1-72-2.svg": "7d69",
	"./q1-72-3.svg": "1975",
	"./q1-73-0.svg": "e7fa",
	"./q1-73-1.svg": "1a4c",
	"./q1-73-2.svg": "7e59",
	"./q1-73-3.svg": "26e7",
	"./q1-74-0.svg": "3ed0",
	"./q1-74-1.svg": "34b3",
	"./q1-74-2.svg": "dc52",
	"./q1-74-3.svg": "dc7b",
	"./q1-75-0.svg": "737f",
	"./q1-75-1.svg": "ffd7",
	"./q1-75-2.svg": "5fe7",
	"./q1-75-3.svg": "aecd",
	"./q1-76-0.svg": "ce8d",
	"./q1-76-1.svg": "84de",
	"./q1-76-2.svg": "04cf",
	"./q1-76-3.svg": "57db",
	"./q1-77-0.svg": "15e3",
	"./q1-77-1.svg": "cefff",
	"./q1-77-2.svg": "bd10",
	"./q1-77-3.svg": "ff51",
	"./q1-78-0.svg": "159bc",
	"./q1-78-1.svg": "e750",
	"./q1-78-2.svg": "6148",
	"./q1-78-3.svg": "16a7",
	"./q1-79-0.svg": "3297",
	"./q1-79-1.svg": "0767",
	"./q1-79-2.svg": "bc82",
	"./q1-79-3.svg": "a1cb",
	"./q1-8-0.svg": "d1fc",
	"./q1-8-1.svg": "b5d0",
	"./q1-8-2.svg": "f30d",
	"./q1-8-3.svg": "b511",
	"./q1-80-0.svg": "c5d1",
	"./q1-80-1.svg": "74f4",
	"./q1-80-2.svg": "666a",
	"./q1-80-3.svg": "b20c",
	"./q1-81-0.svg": "bf1b",
	"./q1-81-1.svg": "68d0",
	"./q1-81-2.svg": "eb26",
	"./q1-81-3.svg": "b07a",
	"./q1-82-0.svg": "8baa",
	"./q1-82-1.svg": "fc67",
	"./q1-82-2.svg": "1df8",
	"./q1-82-3.svg": "1d81",
	"./q1-83-0.svg": "d2c8",
	"./q1-83-1.svg": "3204",
	"./q1-83-2.svg": "0d92",
	"./q1-83-3.svg": "e5f8",
	"./q1-84-0.svg": "5266",
	"./q1-84-1.svg": "ae54",
	"./q1-84-2.svg": "3232",
	"./q1-84-3.svg": "e19a",
	"./q1-85-0.svg": "5b40",
	"./q1-85-1.svg": "59ba",
	"./q1-85-2.svg": "c1ed",
	"./q1-85-3.svg": "3f2c",
	"./q1-86-0.svg": "f363",
	"./q1-86-1.svg": "db4a",
	"./q1-86-2.svg": "880a",
	"./q1-86-3.svg": "7269",
	"./q1-87-0.svg": "1909",
	"./q1-87-1.svg": "a37a",
	"./q1-87-2.svg": "f7fd",
	"./q1-87-3.svg": "9809",
	"./q1-88-0.svg": "725f",
	"./q1-88-1.svg": "2a6d",
	"./q1-88-2.svg": "653ca",
	"./q1-88-3.svg": "4b2c",
	"./q1-89-0.svg": "b8dc",
	"./q1-89-1.svg": "879e",
	"./q1-89-2.svg": "9693",
	"./q1-89-3.svg": "78b1",
	"./q1-9-0.svg": "9a06",
	"./q1-9-1.svg": "f2cf",
	"./q1-9-2.svg": "ff2a",
	"./q1-9-3.svg": "6feb",
	"./q1-90-0.svg": "b0bf",
	"./q1-90-1.svg": "22d8",
	"./q1-90-2.svg": "23e0",
	"./q1-90-3.svg": "b7ab",
	"./q1-91-0.svg": "ef10",
	"./q1-91-1.svg": "d213",
	"./q1-91-2.svg": "667a",
	"./q1-91-3.svg": "ab64",
	"./q1-92-0.svg": "2d54",
	"./q1-92-1.svg": "2ffc",
	"./q1-92-2.svg": "55b6",
	"./q1-92-3.svg": "4c17",
	"./q1-93-0.svg": "98a41",
	"./q1-93-1.svg": "a835",
	"./q1-93-2.svg": "8b90",
	"./q1-93-3.svg": "3ce8",
	"./q1-94-0.svg": "bebe",
	"./q1-94-1.svg": "47e5",
	"./q1-94-2.svg": "39c0",
	"./q1-94-3.svg": "cd13",
	"./q1-95-0.svg": "1559",
	"./q1-95-1.svg": "06b4",
	"./q1-95-2.svg": "7afa",
	"./q1-95-3.svg": "d166",
	"./q1-96-0.svg": "dd1d",
	"./q1-96-1.svg": "591c",
	"./q1-96-2.svg": "7826",
	"./q1-96-3.svg": "ce09",
	"./q1-97-0.svg": "90ad",
	"./q1-97-1.svg": "e941",
	"./q1-97-2.svg": "44bc",
	"./q1-97-3.svg": "63a2",
	"./q1-98-0.svg": "3a6c",
	"./q1-98-1.svg": "ac8d",
	"./q1-98-2.svg": "cd93",
	"./q1-98-3.svg": "ecdf",
	"./q1-99-0.svg": "2bb4",
	"./q1-99-1.svg": "5e39",
	"./q1-99-2.svg": "b115",
	"./q1-99-3.svg": "d431",
	"./q2-0.svg": "7285",
	"./q2-1-0.svg": "ac60",
	"./q2-1-1.svg": "fd0f",
	"./q2-1-2.svg": "6e77f",
	"./q2-1-3.svg": "f279",
	"./q2-1-4.svg": "9950",
	"./q2-1.svg": "acb4",
	"./q2-10-0.svg": "b6ca",
	"./q2-10-1.svg": "e35a",
	"./q2-10-2.svg": "ec6b",
	"./q2-10-3.svg": "fc9a",
	"./q2-10-4.svg": "088d",
	"./q2-100-0.svg": "ea8f",
	"./q2-100-1.svg": "45d1",
	"./q2-100-2.svg": "614d",
	"./q2-100-3.svg": "eb41",
	"./q2-11-0.svg": "e783",
	"./q2-11-1.svg": "e274",
	"./q2-11-2.svg": "a289",
	"./q2-11-3.svg": "0c70",
	"./q2-12-0.svg": "2f6e",
	"./q2-12-1.svg": "913f",
	"./q2-12-2.svg": "bfcf",
	"./q2-12-3.svg": "b582",
	"./q2-12-4.svg": "dc2d",
	"./q2-13-0.svg": "5db35",
	"./q2-13-1.svg": "4de6",
	"./q2-13-2.svg": "f95a",
	"./q2-13-3.svg": "dc13",
	"./q2-14-0.svg": "b1175",
	"./q2-14-1.svg": "b3bc",
	"./q2-14-2.svg": "a6b63",
	"./q2-14-3.svg": "7728",
	"./q2-14-4.svg": "daa9",
	"./q2-15-0.svg": "dc8b",
	"./q2-15-1.svg": "d881",
	"./q2-15-2.svg": "4df5",
	"./q2-15-3.svg": "2b5b",
	"./q2-16-0.svg": "a6f2",
	"./q2-16-1.svg": "1aeb",
	"./q2-16-2.svg": "1a5c",
	"./q2-16-3.svg": "2584",
	"./q2-17-0.svg": "b8cd",
	"./q2-17-1.svg": "edf0",
	"./q2-17-2.svg": "974d",
	"./q2-17-3.svg": "5ee6",
	"./q2-17-4.svg": "a8d9e",
	"./q2-18-0.svg": "7e4e",
	"./q2-18-1.svg": "702e",
	"./q2-18-2.svg": "6dd2",
	"./q2-18-3.svg": "b84c",
	"./q2-19-0.svg": "a369",
	"./q2-19-1.svg": "f99c",
	"./q2-19-2.svg": "986f",
	"./q2-19-3.svg": "e4ca",
	"./q2-2-0.svg": "0308",
	"./q2-2-1.svg": "f0193",
	"./q2-2-2.svg": "e988",
	"./q2-2-3.svg": "0cd6",
	"./q2-2.svg": "ddb9",
	"./q2-20-0.svg": "7c97",
	"./q2-20-1.svg": "5af8",
	"./q2-20-2.svg": "75f3",
	"./q2-20-3.svg": "b09c",
	"./q2-21-0.svg": "d9aa",
	"./q2-21-1.svg": "917f",
	"./q2-21-2.svg": "0b1b",
	"./q2-21-3.svg": "c63b",
	"./q2-22-0.svg": "3f88",
	"./q2-22-1.svg": "7264",
	"./q2-22-2.svg": "f1256",
	"./q2-22-3.svg": "8605",
	"./q2-23-0.svg": "27e8",
	"./q2-23-1.svg": "8938",
	"./q2-23-2.svg": "65bf",
	"./q2-23-3.svg": "729f",
	"./q2-24-0.svg": "029c",
	"./q2-24-1.svg": "732f",
	"./q2-24-2.svg": "8a1d",
	"./q2-24-3.svg": "b834",
	"./q2-25-0.svg": "c8ac",
	"./q2-25-1.svg": "a10a",
	"./q2-25-2.svg": "ba54e",
	"./q2-25-3.svg": "a74e",
	"./q2-26-0.svg": "8b25",
	"./q2-26-1.svg": "3a61",
	"./q2-26-2.svg": "2592",
	"./q2-26-3.svg": "e01a",
	"./q2-27-0.svg": "7144",
	"./q2-27-1.svg": "0940",
	"./q2-27-2.svg": "1405",
	"./q2-27-3.svg": "868f",
	"./q2-28-0.svg": "e9b0",
	"./q2-28-1.svg": "7fde",
	"./q2-28-2.svg": "050a",
	"./q2-28-3.svg": "7c2c",
	"./q2-29-0.svg": "0366",
	"./q2-29-1.svg": "7c28",
	"./q2-29-2.svg": "3add",
	"./q2-29-3.svg": "032e",
	"./q2-3-0.svg": "5b4b",
	"./q2-3-1.svg": "8368",
	"./q2-3-2.svg": "074b",
	"./q2-3-3.svg": "b3543",
	"./q2-3.svg": "2579",
	"./q2-30-0.svg": "2415",
	"./q2-30-1.svg": "6a01",
	"./q2-30-2.svg": "807e",
	"./q2-30-3.svg": "892e",
	"./q2-31-0.svg": "7444",
	"./q2-31-1.svg": "9848",
	"./q2-31-2.svg": "1fbb",
	"./q2-31-3.svg": "f439",
	"./q2-32-0.svg": "cc0d",
	"./q2-32-1.svg": "d048",
	"./q2-32-2.svg": "61de",
	"./q2-32-3.svg": "9fb8",
	"./q2-33-0.svg": "f649",
	"./q2-33-1.svg": "d345",
	"./q2-33-2.svg": "c8b7",
	"./q2-33-3.svg": "853b",
	"./q2-34-0.svg": "626b",
	"./q2-34-1.svg": "5dc9",
	"./q2-34-2.svg": "09dc",
	"./q2-34-3.svg": "7366",
	"./q2-35-0.svg": "13cc",
	"./q2-35-1.svg": "a86e",
	"./q2-35-2.svg": "ad16",
	"./q2-35-3.svg": "57d9c",
	"./q2-36-0.svg": "beb3",
	"./q2-36-1.svg": "1433",
	"./q2-36-2.svg": "6bcd8",
	"./q2-36-3.svg": "115b",
	"./q2-37-0.svg": "55ea",
	"./q2-37-1.svg": "da79",
	"./q2-37-2.svg": "c21c",
	"./q2-37-3.svg": "6cc0",
	"./q2-38-0.svg": "e73a",
	"./q2-38-1.svg": "1a81",
	"./q2-38-2.svg": "bc829",
	"./q2-38-3.svg": "2a7d",
	"./q2-39-0.svg": "26b1",
	"./q2-39-1.svg": "ddd8",
	"./q2-39-2.svg": "682b",
	"./q2-39-3.svg": "5644",
	"./q2-4-0.svg": "fb4a",
	"./q2-4-1.svg": "69f6",
	"./q2-4-2.svg": "8383",
	"./q2-4-3.svg": "1466",
	"./q2-4-4.svg": "9213",
	"./q2-40-0.svg": "3ff4",
	"./q2-40-1.svg": "ba4c",
	"./q2-40-2.svg": "29d9",
	"./q2-40-3.svg": "4bbc",
	"./q2-41-0.svg": "1b9f",
	"./q2-41-1.svg": "efa9",
	"./q2-41-2.svg": "653e",
	"./q2-41-3.svg": "9800",
	"./q2-42-0.svg": "c382",
	"./q2-42-1.svg": "c861",
	"./q2-42-2.svg": "b220",
	"./q2-42-3.svg": "3119",
	"./q2-43-0.svg": "25ee",
	"./q2-43-1.svg": "15f0",
	"./q2-43-2.svg": "b584",
	"./q2-43-3.svg": "c728",
	"./q2-44-0.svg": "5b10",
	"./q2-44-1.svg": "aa07",
	"./q2-44-2.svg": "a1d2",
	"./q2-44-3.svg": "865d",
	"./q2-45-0.svg": "c81c",
	"./q2-45-1.svg": "4c57",
	"./q2-45-2.svg": "a12d",
	"./q2-45-3.svg": "0f1e",
	"./q2-46-0.svg": "afed",
	"./q2-46-1.svg": "3883",
	"./q2-46-2.svg": "1a0f",
	"./q2-46-3.svg": "9a03",
	"./q2-47-0.svg": "3d81",
	"./q2-47-1.svg": "8cd2",
	"./q2-47-2.svg": "b3f3",
	"./q2-47-3.svg": "b25a5",
	"./q2-48-0.svg": "a60e",
	"./q2-48-1.svg": "4c1a",
	"./q2-48-2.svg": "0446",
	"./q2-48-3.svg": "6873",
	"./q2-49-0.svg": "9d68",
	"./q2-49-1.svg": "8ebf",
	"./q2-49-2.svg": "8d4c",
	"./q2-49-3.svg": "3127",
	"./q2-5-0.svg": "aaca",
	"./q2-5-1.svg": "c255",
	"./q2-5-2.svg": "7cad",
	"./q2-5-3.svg": "8d1e",
	"./q2-50-0.svg": "dfca",
	"./q2-50-1.svg": "c108",
	"./q2-50-2.svg": "d53a",
	"./q2-50-3.svg": "8ff5",
	"./q2-51-0.svg": "83fe",
	"./q2-51-1.svg": "73e8",
	"./q2-51-2.svg": "5666",
	"./q2-51-3.svg": "d29d",
	"./q2-52-0.svg": "de60",
	"./q2-52-1.svg": "83fd",
	"./q2-52-2.svg": "d759",
	"./q2-52-3.svg": "b5f9",
	"./q2-53-0.svg": "ba84",
	"./q2-53-1.svg": "a5ff",
	"./q2-53-2.svg": "ee56",
	"./q2-53-3.svg": "af90",
	"./q2-54-0.svg": "7e94",
	"./q2-54-1.svg": "db7c",
	"./q2-54-2.svg": "9955",
	"./q2-54-3.svg": "e0f1",
	"./q2-55-0.svg": "fc35",
	"./q2-55-1.svg": "2da4",
	"./q2-55-2.svg": "2c69",
	"./q2-55-3.svg": "98d2",
	"./q2-56-0.svg": "e511",
	"./q2-56-1.svg": "24eb",
	"./q2-56-2.svg": "4077",
	"./q2-56-3.svg": "7b6b",
	"./q2-57-0.svg": "e427",
	"./q2-57-1.svg": "f621",
	"./q2-57-2.svg": "a02f",
	"./q2-57-3.svg": "2354",
	"./q2-58-0.svg": "13c9",
	"./q2-58-1.svg": "d86b3",
	"./q2-58-2.svg": "dcbf",
	"./q2-58-3.svg": "6043",
	"./q2-59-0.svg": "07f1",
	"./q2-59-1.svg": "592c",
	"./q2-59-2.svg": "0eee",
	"./q2-59-3.svg": "62e5",
	"./q2-6-0.svg": "e541",
	"./q2-6-1.svg": "66ad",
	"./q2-6-2.svg": "05818",
	"./q2-6-3.svg": "7ffe",
	"./q2-6-4.svg": "17e1",
	"./q2-60-0.svg": "ece9",
	"./q2-60-1.svg": "4169",
	"./q2-60-2.svg": "daf1",
	"./q2-60-3.svg": "ff41",
	"./q2-61-0.svg": "7200",
	"./q2-61-1.svg": "7cdb",
	"./q2-61-2.svg": "ccbb",
	"./q2-61-3.svg": "d926",
	"./q2-62-0.svg": "6ebf",
	"./q2-62-1.svg": "d3e0",
	"./q2-62-2.svg": "d10aa",
	"./q2-62-3.svg": "aca6",
	"./q2-63-0.svg": "06cd",
	"./q2-63-1.svg": "4851",
	"./q2-63-2.svg": "9176",
	"./q2-63-3.svg": "805d",
	"./q2-64-0.svg": "0006",
	"./q2-64-1.svg": "3d3d",
	"./q2-64-2.svg": "aa91",
	"./q2-64-3.svg": "08c7",
	"./q2-65-0.svg": "3d5d",
	"./q2-65-1.svg": "32cf",
	"./q2-65-2.svg": "92a7",
	"./q2-65-3.svg": "4360",
	"./q2-66-0.svg": "edd7",
	"./q2-66-1.svg": "add8",
	"./q2-66-2.svg": "d537",
	"./q2-66-3.svg": "4bf7",
	"./q2-67-0.svg": "553e",
	"./q2-67-1.svg": "3bcd",
	"./q2-67-2.svg": "93703",
	"./q2-67-3.svg": "5d9a",
	"./q2-68-0.svg": "4cbd",
	"./q2-68-1.svg": "c483",
	"./q2-68-2.svg": "ad01",
	"./q2-68-3.svg": "6d0a",
	"./q2-69-0.svg": "63d6",
	"./q2-69-1.svg": "8e1b",
	"./q2-69-2.svg": "e289",
	"./q2-69-3.svg": "2e56",
	"./q2-7-0.svg": "d533",
	"./q2-7-1.svg": "7fb4",
	"./q2-7-2.svg": "f0a4",
	"./q2-7-3.svg": "fd464",
	"./q2-70-0.svg": "1f2f",
	"./q2-70-1.svg": "94a9",
	"./q2-70-2.svg": "6e80",
	"./q2-70-3.svg": "aa87",
	"./q2-71-0.svg": "75b7",
	"./q2-71-1.svg": "58c8",
	"./q2-71-2.svg": "e130",
	"./q2-71-3.svg": "ea7e",
	"./q2-72-0.svg": "1821",
	"./q2-72-1.svg": "c79c",
	"./q2-72-2.svg": "ab08",
	"./q2-72-3.svg": "58f9",
	"./q2-73-0.svg": "8239",
	"./q2-73-1.svg": "1ca70",
	"./q2-73-2.svg": "2334",
	"./q2-73-3.svg": "ceeb8",
	"./q2-74-0.svg": "c33f",
	"./q2-74-1.svg": "c960",
	"./q2-74-2.svg": "e7d4",
	"./q2-74-3.svg": "aac3",
	"./q2-75-0.svg": "75a8",
	"./q2-75-1.svg": "1854",
	"./q2-75-2.svg": "8357",
	"./q2-75-3.svg": "f9af",
	"./q2-76-0.svg": "73f1",
	"./q2-76-1.svg": "33b5",
	"./q2-76-2.svg": "5a45",
	"./q2-76-3.svg": "7bbdf",
	"./q2-77-0.svg": "0436",
	"./q2-77-1.svg": "fb81",
	"./q2-77-2.svg": "bb61",
	"./q2-77-3.svg": "b1f5",
	"./q2-78-0.svg": "8bd6",
	"./q2-78-1.svg": "d8173",
	"./q2-78-2.svg": "8afa",
	"./q2-78-3.svg": "59f8",
	"./q2-79-0.svg": "15f6",
	"./q2-79-1.svg": "a14d",
	"./q2-79-2.svg": "90dc",
	"./q2-79-3.svg": "b1e3",
	"./q2-8-0.svg": "05b3",
	"./q2-8-1.svg": "9742",
	"./q2-8-2.svg": "fdd1",
	"./q2-8-3.svg": "877f",
	"./q2-80-0.svg": "e48b",
	"./q2-80-1.svg": "abc7",
	"./q2-80-2.svg": "02dd",
	"./q2-80-3.svg": "3d59",
	"./q2-81-0.svg": "0233",
	"./q2-81-1.svg": "1870",
	"./q2-81-2.svg": "0fba",
	"./q2-81-3.svg": "1043",
	"./q2-82-0.svg": "0ea9",
	"./q2-82-1.svg": "9626",
	"./q2-82-2.svg": "ca37",
	"./q2-82-3.svg": "649c",
	"./q2-83-0.svg": "d0a8",
	"./q2-83-1.svg": "437d",
	"./q2-83-2.svg": "baaf",
	"./q2-83-3.svg": "b7d2",
	"./q2-84-0.svg": "2348",
	"./q2-84-1.svg": "9354",
	"./q2-84-2.svg": "a09b",
	"./q2-84-3.svg": "6ae3",
	"./q2-85-0.svg": "25db",
	"./q2-85-1.svg": "28ea",
	"./q2-85-2.svg": "ede9",
	"./q2-85-3.svg": "e087",
	"./q2-86-0.svg": "f94c",
	"./q2-86-1.svg": "48c5",
	"./q2-86-2.svg": "d5e2",
	"./q2-86-3.svg": "2d19",
	"./q2-87-0.svg": "9d8f",
	"./q2-87-1.svg": "5f3a",
	"./q2-87-2.svg": "c5e7",
	"./q2-87-3.svg": "8b171",
	"./q2-88-0.svg": "6f33",
	"./q2-88-1.svg": "93b6",
	"./q2-88-2.svg": "b61b",
	"./q2-88-3.svg": "a75a",
	"./q2-89-0.svg": "5ab6",
	"./q2-89-1.svg": "42c6c",
	"./q2-89-2.svg": "df93",
	"./q2-89-3.svg": "dbd9",
	"./q2-9-0.svg": "2117",
	"./q2-9-1.svg": "1fde",
	"./q2-9-2.svg": "9e79",
	"./q2-9-3.svg": "75c5",
	"./q2-90-0.svg": "6070",
	"./q2-90-1.svg": "b9b5",
	"./q2-90-2.svg": "74bd",
	"./q2-90-3.svg": "b05a",
	"./q2-91-0.svg": "e5d1",
	"./q2-91-1.svg": "c33f7",
	"./q2-91-2.svg": "15a7",
	"./q2-91-3.svg": "a831",
	"./q2-92-0.svg": "94a3",
	"./q2-92-1.svg": "2e79",
	"./q2-92-2.svg": "5e05",
	"./q2-92-3.svg": "1201",
	"./q2-93-0.svg": "05ba",
	"./q2-93-1.svg": "e8a4",
	"./q2-93-2.svg": "0bcb",
	"./q2-93-3.svg": "29be",
	"./q2-94-0.svg": "951c",
	"./q2-94-1.svg": "04b9",
	"./q2-94-2.svg": "27d36",
	"./q2-94-3.svg": "2276",
	"./q2-95-0.svg": "a67e",
	"./q2-95-1.svg": "d2b4",
	"./q2-95-2.svg": "370a",
	"./q2-95-3.svg": "fe44",
	"./q2-96-0.svg": "3a54e",
	"./q2-96-1.svg": "4010",
	"./q2-96-2.svg": "33ce",
	"./q2-96-3.svg": "d726",
	"./q2-97-0.svg": "43ea",
	"./q2-97-1.svg": "b832",
	"./q2-97-2.svg": "1d7a",
	"./q2-97-3.svg": "2fd0",
	"./q2-98-0.svg": "6b33",
	"./q2-98-1.svg": "5ccd",
	"./q2-98-2.svg": "8603",
	"./q2-98-3.svg": "e1fc",
	"./q2-99-0.svg": "8169",
	"./q2-99-1.svg": "d88d",
	"./q2-99-2.svg": "bfe2",
	"./q2-99-3.svg": "7424",
	"./q3-0.svg": "a1f8",
	"./q3-1.svg": "4ddc",
	"./q3-2.svg": "05ad",
	"./q3-3.svg": "ec58"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fee";